/* Native recommendation feed, using the existing mockup card renderer. */
(() => {
 'use strict';
 function endpoint(root,productId,requestedLimit=4){
  const number=Number(requestedLimit),limit=Number.isInteger(number)&&number>=2&&number<=5?number:4;
  const url=new URL('recommendations/products',root);
  url.search=new URLSearchParams({product_id:String(productId),section_id:'liotro-recommendations-data',limit:String(limit),intent:'related'});
  return url.href;
 }
 function decode(html){
  const doc=new DOMParser().parseFromString(html,'text/html'),data=doc.querySelector('[data-liotro-recommendation-data]'),cards=doc.querySelector('[data-liotro-recommendation-cards] .shop-grid');
  if(!data||!cards)throw Error('Incomplete recommendation response');
  const payload=JSON.parse(data.content.textContent);
  if(!Array.isArray(payload.products)||payload.products.some(p=>!p?.handle)||cards.children.length!==payload.products.length)throw Error('Invalid recommendations');
  return {...payload,cards};
 }
 function createLoader({root,productId,limit=4,request,parse,apply,status}){
  let disposed=false,started=false;
  return {async load(){
   if(disposed||started)return;started=true;status('loading');
   try{const response=await request(endpoint(root,productId,limit),{credentials:'same-origin'});if(!response.ok)throw Error('Recommendations unavailable');const result=parse(await response.text());if(disposed)return;apply(result);status(result.products.length?'ready':'empty');}
   catch(error){if(!disposed)status('error');}
  },dispose(){disposed=true;}};
 }
 window.LiotroRecommendations={endpoint,decode,createLoader};
 if(!window.LiotroLifecycle)return;
 const registry=window.LiotroLifecycle.create({selector:'[data-liotro-recommendations]',setup(node){
  const loader=createLoader({root:rootURL,productId:node.dataset.productId,limit:node.dataset.recommendationLimit,request:fetch,parse:decode,status(value){node.dataset.recommendationsState=value;},apply(result){
   Object.assign(cfg.variantRules,result.variantRules);Object.assign(cfg.presentation,result.presentation);
   // Keep ordinary catalog URLs independent of recommendation click attribution.
   const ordinary=result.products.map(raw=>({...raw,url:find(raw.handle)?.url||new URL('products/'+encodeURIComponent(raw.handle),rootURL).pathname}));
   cfg.products=[...new Map([...cfg.products,...ordinary].map(p=>[p.handle,p])).values()];
   const models=new Map(products.map(p=>[p.handle,p]));for(const raw of ordinary)models.set(raw.handle,productModel(raw));products=[...models.values()].sort((a,b)=>a.rank-b.rank);
   node.querySelector('.shop-grid')?.replaceWith(result.cards);node.hidden=result.products.length===0;hydrate();
  }});
  const observer=typeof IntersectionObserver==='function'?new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){observer.disconnect();loader.load();}},{rootMargin:'200px'}):null;
  if(observer)observer.observe(node);else loader.load();
  return {dispose(){observer?.disconnect();loader.dispose();}};
 }});
 Object.assign(window.LiotroRecommendations,registry);
})();
